import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { GeneralState } from '@core/constants/general-store.constants';

const initialState: GeneralState = {
    state: new Map(),
};

export const GeneralStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withMethods((store) => ({
        update(id: string, generalState: any): void {
            patchState(store, (state) => ({
                state: updateData(id, generalState, state.state),
            }));
        },
        deleteAll(): void {
            patchState(store, (state) => ({
                state: new Map(),
            }));
        },
    })),
);

function updateData(id: string, newState: any, currentState: Map<string, any>) {
    currentState.set(id, newState);

    return currentState;
}
